module.exports = __webpack_public_path__ + "img/WI2010.822e4e6c.jpg";